import { useCallback } from "react";
import Row from "./Row";
import { ITableContentProps } from "./types";

export function TableContent({
  strikeWidth,
  rows,
  rowRefs,
  totalCallsPutsSize,
  onTrade,
  activeInstrumentId,
  mode,
  decimals,
}: ITableContentProps) {
  const sideTableWidth: string =
    mode === "both" ? `calc((100% - ${strikeWidth}px)/2)` : "100%";

  const assignRef = useCallback(
    (ref: HTMLDivElement, index: number) => {
      // eslint-disable-next-line no-param-reassign
      rowRefs.current[index] = ref;
    },
    [rowRefs]
  );

  return (
    <div>
      {rows.map((row, index) => (
        <Row
          // eslint-disable-next-line no-param-reassign
          ref={(ref) => assignRef(ref, index)}
          decimals={decimals}
          activeInstrumentId={activeInstrumentId}
          key={row.strike || `placeholder-${index}`}
          row={row}
          mode={mode}
          onTrade={onTrade}
          sideTableWidth={sideTableWidth}
          totalCallsPutsSize={totalCallsPutsSize}
          strikeWidth={strikeWidth}
        />
      ))}
    </div>
  );
}
